import { render } from "./UiDataProps.vue?vue&type=template&id=27a9609a&scoped=true"
import script from "./UiDataProps.vue?vue&type=script&lang=js"
export * from "./UiDataProps.vue?vue&type=script&lang=js"

import "./UiDataProps.vue?vue&type=style&index=0&id=27a9609a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a9609a"]])

export default __exports__